export const BASE_PATH = '/arfbr'

export const arfbrBooksPath = () => `${BASE_PATH}/books`
export const arfbrWebCPath = () => `${BASE_PATH}/webc`
